import firebase, { perf, analytics } from '@/firebase-init'
import Geohash from 'latlon-geohash'
import moment from 'moment'

export default {
  state: {
    user: null,
    newUser: false,
    userLocation: null
  },
  mutations: {
    setUser(state, payload) {
      state.user = payload
    },
    setNewUser(state, payload) {
      state.newUser = payload
    },
    setUserlocation(state, payload) {
      state.userLocation = payload
    }
  },
  actions: {
    signUserUp({ commit, dispatch }, payload) {
      commit('setLoading', true)
      commit('clearError')
      console.log('Signup request:', payload)

      firebase
        .auth()
        .createUserWithEmailAndPassword(payload.email, payload.password)
        .then(data => {
          let user = data.user
          if (!user) {
            console.error('User not bounded')
            commit('setError', { message: 'Unable to create user!' })
            return
          }

          analytics.logEvent('sign_up', {
            method: 'email',
            isAnonymous: user.isAnonymous,
            emailVerified: user.emailVerified
          })
          commit('setLoading', false)
          const newUser = {
            id: user.uid,
            name: payload.name ? payload.name : user.displayName || user.email,
            phone: payload.phone,
            email: user.email,
            invitation_id: payload.invitation_id,
            photoUrl: user.photoUrl,
            avatar: user.avatar || user.photoUrl,
            newProfile: true,
            type: 'customer'
          }
         
          commit('setUser', newUser)
          dispatch('saveProfile', newUser)
         
          user
            .sendEmailVerification()
            .then(function(emailSent) {
              console.log('emailSent ', emailSent)
            })
            .catch(function(error) {
              console.log('emailSent error ', error)
            })
        })
        .catch(error => {
          commit('setLoading', false)
          commit('setError', error)
          console.log(error)
        })
    },
    signUserIn({ commit }, payload) {
      commit('setLoading', true)
      commit('clearError')
      firebase
        .auth()
        .signInWithEmailAndPassword(payload.email, payload.password)
        .then(user => {
          console.log('logged user:', user)
          commit('setLoading', false)
          analytics.logEvent('login', {
            method: 'email',
            isAnonymous: user.isAnonymous,
            emailVerified: user.emailVerified
          })
          const newUser = {
            id: user.uid,
            name: user.displayName,
            email: user.email,
            invitation_id: payload.invitation_id,
            avatar: user.avatar || user.photoUrl,
            photoUrl: user.photoUrl
          }
          commit('setUser', newUser)
        })
        .catch(error => {
          commit('setLoading', false)
          //commit('setError', error)
          commit('setError', {
            message:
              'An invalid User ID or Password was entered. Please try again. '
          })
          console.log(error)
        })
    },
    signUserInGoogle({ commit, dispatch }, payload) {
      commit('setLoading', true)
      commit('clearError')
      firebase
        .auth()
        .signInWithPopup(new firebase.auth.GoogleAuthProvider())
        .then(data => {
          let user = data.user
          console.log('google user', user)
          console.log('payload', payload)

          commit('setLoading', false)
          analytics.logEvent('login', {
            method: 'google',
            isAnonymous: user.isAnonymous,
            emailVerified: user.emailVerified
          })
          const newUser = {
            id: user.uid,
            name: user.displayName,
            email: user.email,
            avatar: user.photoURL ? user.photoURL : user.photoUrl,
            type: 'customer'
          }

          commit('setUser', newUser)

          if (data.additionalUserInfo.isNewUser) {
            newUser.type = 'customer'
            newUser.newProfile = true
            dispatch('saveProfile', newUser)
          }
        })
        .catch(error => {
          commit('setLoading', false)
          commit('setError', error)
          console.log(error)
        })
    },
    signUserWithPhone({ commit, dispatch }, payload) {
      payload.confirmationResult
        .confirm(payload.verificationCode)
        .then(function(result) {
          // User signed in successfully.
          var user = result.user
          console.log('result', result)
          console.log('User', user)
          analytics.logEvent('login', {
            method: 'phone',
            isAnonymous: user.isAnonymous,
            emailVerified: user.emailVerified
          })
          const newUser = {
            id: user.uid,
            name: user.displayName,
            email: user.email,
            phone: user.phone,
            avatar: user.avatar || user.photoUrl,
            photoUrl: user.photoUrl,
            type: 'customer'
          }

          commit('setUser', newUser)
          if (result.additionalUserInfo.isNewUser) {
            newUser.newProfile = true
            dispatch('saveProfile', newUser)
          }

          // ...
        })
        .catch(function(error) {
          console.log(error)
          // User couldn't sign in (bad verification code?)
          // ...
        })
      // Redirect the user to the authenticated page
    },
    signUserInFacebook({ commit, dispatch }, payload) {
      commit('setLoading', true)
      commit('clearError')
      firebase
        .auth()
        .signInWithPopup(new firebase.auth.FacebookAuthProvider())
        .then(data => {
          let user = data.user
          console.log('Facebook user', data)
          console.log('payload', payload)

          commit('setLoading', false)
          analytics.logEvent('login', {
            method: 'facebook',
            isAnonymous: user.isAnonymous,
            emailVerified: user.emailVerified
          })
          const newUser = {
            id: user.uid,
            name: user.displayName,
            email: user.email,
            avatar: user.avatar || user.photoUrl,
            photoUrl: user.photoUrl,
            type: 'customer'
          }
          commit('setUser', newUser)

          if (data.additionalUserInfo.isNewUser) {
            newUser.newProfile = true
            newUser.type = 'customer'
            dispatch('saveProfile', newUser)
          }

          console.log('Facebook user:', user)
          if (!user.emailVerified) {
            firebase
              .auth()
              .currentUser.sendEmailVerification()
              .then(function() {
                console.log('emailSent ', user.email)
              })
              .catch(function(error) {
                console.log('emailSent error ', error)
              })
          }
        })
        .catch(error => {
          commit('setLoading', false)
          commit('setError', error)
          console.log(error)
        })
    },
    signUserInTwitter({ commit, dispatch }, payload) {
      commit('setLoading', true)
      commit('clearError')
      firebase
        .auth()
        .signInWithPopup(new firebase.auth.TwitterAuthProvider())
        .then(data => {
          let user = data.user
          console.log('Twitter user', data)
          const newUser = {
            id: user.uid,
            name: user.displayName,
            email: user.email,
            avatar: user.avatar || user.photoUrl,
            photoUrl: user.photoUrl,
            type: 'customer'
          }
          commit('setUser', newUser)

          if (data.additionalUserInfo.isNewUser) {
            newUser.newProfile = true
            dispatch('saveProfile', newUser)
          }
          analytics.logEvent('login', {
            method: 'twitter',
            isAnonymous: user.isAnonymous,
            emailVerified: user.emailVerified
          })
          if (!user.emailVerified) {
            firebase
              .auth()
              .currentUser.sendEmailVerification()
              .then(function(emailSent) {
                console.log('emailSent ', emailSent)
              })
              .catch(function(error) {
                console.log('emailSent error ', error)
              })
          }
        })
        .catch(error => {
          commit('setLoading', false)
          commit('setError', error)
          console.log(error)
        })
    },
    SaveUserLocation({ commit }, payload) {
      if (payload) {
        commit('setUserlocation', payload)
      }
    },

    setUserLocation({ commit, getters, dispatch }) {
      var options = {
        enableHighAccuracy: false,
        timeout: 10000,
        maximumAge: 600000
      }
      console.log('Getting GPS location and saving to storage')
      commit('setLoading', true)
      return getPosition(options)
        .then(position => {
          let lowGeohash = Geohash.encode(
            position.coords.latitude,
            position.coords.longitude,
            7
          )
          let highGeohash = Geohash.encode(
            position.coords.latitude,
            position.coords.longitude,
            this.precision
          )
          console.log(`HighGeohash precision ${this.precision}`, position)
          let userLocation = {
            lowGeohash: lowGeohash,
            highGeohash: highGeohash,
            latitude: position.coords.latitude,
            longitude: position.coords.longitude
          }
          commit('setLoading', false)
          console.log('userLocation', userLocation)
          commit('setUserlocation', userLocation)
          return userLocation
        })
        .catch(err => {
          commit('setLoading', false)
          console.error(err)
          // if (err.code && err.code == 3) {
          //timeout
          // Setting user's profile location
          if (getters.profile && getters.defaultAddress) {
            let userLocation = {
              lat: getters.defaultAddress.latitude,
              lng: getters.defaultAddress.longitude
            }
            dispatch('saveUserLocation', userLocation)
          } else {
            //let userLocation = this.$localStorage.get('userlocation')
            //console.log('Saved userLocation from LS', userLocation)
            //return null
          }
          return null
          //}
        })
    },
    saveUserLocation({ commit }, location) {
      let lat = location.lat || location.latitude
      let lng = location.lng || location.longitude
      let lowGeohash = Geohash.encode(lat, lng, 7)
      let highGeohash = Geohash.encode(lat, lng)
      let userLocation = {
        lowGeohash: lowGeohash,
        highGeohash: highGeohash,
        latitude: lat,
        longitude: lng
      }

      console.log('user location', userLocation)
      commit('setUserlocation', userLocation)
    },
    saveUserFCMToken({ getters }, token) {
      console.log(`Saving FCM Token: ${uid} platform: ${navigator.platform} : `, token)
      let uid = getters.user.id
      
      firebase
        .firestore()
        .collection('profile')
        .doc(uid)
        .collection('fcm_token')
        .doc(navigator.platform)
        .set({
          token: token,
          updated: moment.utc().valueOf()
        }, {merge:true}).catch( e => console.error('Saving error', e))
    },
    autoSignIn({ commit, dispatch }, payload) {
      console.log('autoSignIn:', payload)

      if (
        payload &&
        payload.metadata.creationTime == payload.metadata.lastSignInTime
      ) {
        // this is is new user
        commit('setNewUser', true)
      }
      analytics.logEvent('login', {
        isAnonymous: payload.isAnonymous,
        emailVerified: payload.emailVerified
      })
      commit('setUser', {
        id: payload.uid,
        name: payload.displayName,
        email: payload.email,
        phoneNumber: payload.phoneNumber,
        avatar:
          payload.avatar ||
          (payload.photoURL ? payload.photoURL : payload.photoUrl),
        //photoUrl: payload.photoURL,
        emailVerified: payload.emailVerified
      })
      var ua = navigator.userAgent.toLowerCase()

      if (ua.indexOf('safari') != -1) {
        if (ua.indexOf('chrome') <= -1) {
          console.log('Skipping FCM permission check')
          commit('setLoading', false)
          return
        }
      }

      const trace = perf.trace('userLoginTrace')
      trace.start()

      const messaging = firebase.messaging()
      messaging
        .requestPermission()
        .then(function() {
          console.log('Notification permission granted.')
          return messaging.getToken()
        })
        .then(t => {
          console.log('token', t)
          commit('setUser', {
            token: t,
            id: payload.uid,
            name: payload.displayName,
            email: payload.email,
            avatar: payload.avatar || payload.photoUrl,
            photoUrl: payload.photoUrl,
            emailVerified: payload.emailVerified
          })
          dispatch('saveUserFCMToken', t)

          trace.stop()
        })
        .catch(function(err) {
          trace.stop()
          commit('setLoading', false)
          console.log('Unable to get permission to notify.', err)
        })
    },
    resetPassword({ commit }, payload) {
      firebase
        .auth()
        .sendPasswordResetEmail(payload)
        .then(function() {
          console.log('Reset password sent to ', payload)
        })
        .catch(function(error) {
          commit('setError', error)
          console.log(error)
        })
    },
    changePassword({ commit }, newPassword) {
      var user = firebase.auth().currentUser
      var credential = firebase.auth.EmailAuthProvider.credential(
        user.email,
        newPassword
      )
      return user
        .updatePassword(newPassword)
        .then(function() {
          console.log('Password update')
          return user
            .reauthenticateWithCredential(credential)
            .then(function() {
              commit('setMessage', {
                title: 'Password Update',
                body: 'Thanks for update'
              })
            })
            .catch(function(error) {
              commit('setError', error)
              console.error(error)
            })
        })
        .catch(function(error) {
          commit('setError', error)
          console.error('Error on change password:', error)
        })
    },
    logout: async ({commit}) => {    
      await firebase.auth().signOut()
      
      commit('setUser', null)
      commit('setProfile', null)
      document.cookie = '__session='
    },
    deleteAccount({ commit, getters }) {
      let uid = getters.user.id
      let name = getters.user.name
      let email = getters.user.email

      firebase
        .firestore()
        .collection('profile')
        .doc(uid)
        .collection('actions')
        .add({ action: 'delete', name, email })
        .then(() => {
          console.log('Delete requested')
          firebase.auth().signOut()
          commit('setProfile', null)
          commit('setUser', null)
          document.cookie = '__session='
        })
        .catch(error => {
          console.error('Error deleting account: ', error)
          commit('setError', error)
        })
    }
  },
  getters: {
    user(state) {
      return state.user
    },
    newUser: state => state.newUser,
    userVerified(state) {
      return state.user ? state.user.emailVerified : false
    },
    userLocation(state) {
      return state.userLocation
    }
  }
}

/*var getPosition2 = function(options) {
  return new Promise(function(resolve, reject) {
    navigator.geolocation.getCurrentPosition(resolve, reject, options)
  })
}*/
var getPosition = function(options) {
  if (navigator.geolocation) {
    return new Promise((resolve, reject) =>
      navigator.geolocation.getCurrentPosition(resolve, reject, options)
    )
  } else {
    console.error('Location service is off or unable to get the location')
    return new Promise(resolve => resolve({}))
  }
}
